import { createAsyncThunk } from '@reduxjs/toolkit';

import { sendSentryClientErrorOnce } from 'shared/lib/sendSentryClientError';
import type { TOffer } from 'shared/types/TRankingService';

import { getStAffAndOfferFromUrl, getStParentId } from '../../lib';
import { stTrackingApi } from '../stTracking.query';

export const resolveStOrderIdThunk = createAsyncThunk<string | null, TOffer>(
  'offerControls/resolveStOrderIdThunk',
  async (offer, { dispatch }) => {
    try {
      const stParentId = getStParentId();
      const stAffAndOffer = getStAffAndOfferFromUrl(offer.additionalInfo?.displayPixelUrl);

      if (!stParentId || !stAffAndOffer) {
        return null;
      }

      const response = await dispatch(
        stTrackingApi.endpoints.stTrackingClick.initiate({
          affId: stAffAndOffer.affId,
          offerId: stAffAndOffer.offerId,
          rootTransactionId: stParentId,
        }),
      ).unwrap();

      return response?.transaction_id ?? null;
    } catch (error) {
      sendSentryClientErrorOnce('resolveStOrderIdThunk', error);
      return null;
    }
  },
);
